import * as actionTypes from "./actionTypes";
import { trackSimpleEvent } from "../../helpers/reduxBeacon";

const gaEventsMap = {
  ...trackSimpleEvent(actionTypes.ADD_LOCATION),
  ...trackSimpleEvent(actionTypes.REMOVE_LOCATION)
};

export default gaEventsMap;
